import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import type { IBondScreenerConfig } from '@/creditflowresearch/domain/vo/Bondscreener';
import { useBondScreenerColumns, type IBondScreenerColumnsState } from './useBondScreenerColumns';

const BondScreenerColumnsContext = createContext<IBondScreenerColumnsState | null>(null);

export const useBondScreenerColumnsContext = (): IBondScreenerColumnsState => {
  const context = useContext(BondScreenerColumnsContext);

  if (!context) {
    throw new Error('useBondScreenerColumnsContext must be used within BondScreenerColumnsProvider');
  }

  return context;
};

interface IBondScreenerColumnsProviderProps extends PropsWithChildren {
  config: IBondScreenerConfig,
  initialActiveColumnsIds?: string[],
}

export const BondScreenerColumnsProvider = ({
  children,
  config,
  initialActiveColumnsIds,
}: IBondScreenerColumnsProviderProps): ReactElement => (
  <BondScreenerColumnsContext.Provider value={ useBondScreenerColumns(config, initialActiveColumnsIds) }>
    { children }
  </BondScreenerColumnsContext.Provider>
);
